import { Checkbox } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import InvestorRowActions from './InvestorRowActions';
import type { CardViewLinkHrefs } from '../CardViewLinks';
import PipelineRowCard from '../PipelineRowCard';

export interface InvestorListRowContact {
  name: string;
  email: string;
  investment?: number | null;
  contactId: string;
  onPromote?: () => void;
  onDemote?: () => void;
  onDelete?: () => void;
  entity: { id: string };
  viewLinks?: CardViewLinkHrefs;
}

export interface InvestorListRowProps {
  contact: InvestorListRowContact;
  promotionStageLabel?: string;
  demotionStageLabel?: string;
  isHighlighted?: boolean;
  isInAction?: boolean;
  actionType?: 'promote' | 'demote' | 'delete';
  selectable?: boolean;
  selected?: boolean;
  onToggleSelect?: () => void;
}

const InvestorListRow: React.FC<InvestorListRowProps> = ({
  contact,
  promotionStageLabel,
  demotionStageLabel,
  isHighlighted,
  isInAction,
  actionType,
  selectable,
  selected,
  onToggleSelect,
}) => (
  <PipelineRowCard
    data-contact-id={contact.contactId}
    data-investor-id={contact.entity.id}
    title={contact.name}
    subtitle={contact.email}
    amount={contact.investment}
    viewLinks={contact.viewLinks}
    isHighlighted={isHighlighted}
    isInAction={isInAction}
    leading={
      selectable && (
        <Checkbox
          size="small"
          checked={!!selected}
          onChange={onToggleSelect}
          sx={{
            padding: '2px',
            '&.Mui-checked': { color: Palette.default.buttonBg },
          }}
        />
      )
    }
    actions={
      <InvestorRowActions
        contact={contact}
        promotionStageLabel={promotionStageLabel}
        demotionStageLabel={demotionStageLabel}
        isInAction={isInAction}
        actionType={actionType}
      />
    }
  />
);

export default InvestorListRow;
